// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3hnp6","footer":"ModalFilter_footer__3Z1AV"};